import styles from './University.module.css';
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";
import Banner from '../components/common/banner';
import Breadcrumb from '../components/common/breadcrumb';
import { useEffect, useState } from 'react';
import axios from 'axios';

function UniversityPage() {
  const [listUni, setListUni] = useState([]);

  const getListUniversity = async () => {
    const response = await axios.get("https://duhochanquocnewlife.com/api/universities/getListUniversity")
    setListUni(response.data.data);
  }

  useEffect(() => {
    getListUniversity();
  }, [])

  const toString = (str) => {
    return str
      .trim()
      .split(/\s+/)     // tách theo khoảng trắng
      .slice(0, -1)     // bỏ phần tử cuối
      .map(word => word.toLowerCase())
      .join('_');
  }

  return (
    <>
      <Header />

      <Banner
        imageSrc="/images/university.webp"
        title="Các Trường liên kết tại Hàn Quốc"
      />

      <div className='container'>
        <Breadcrumb />

        <div className={styles.university_page}>
          {listUni.map((item, i) => (
            <div key={item.custom_id} className={styles.university_item}>
              <img src={`/logos/${toString(item.name_en)}_logo.jpg`} alt='Trường Đại học Daegu' />
              <h2 className={styles.kr_name}>{item.name_kr}</h2>
              <h3 className={styles.vn_name}>{item.name_en} - {item.name_vn}</h3>
              <button onClick={() => {
                window.open(`/dai-hoc-han-quoc/${item.url}`)
              }}>
                Xem chi tiết
              </button>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default UniversityPage;